import React from "react";
import styles from "./CircularEaseCard.module.scss";

const CircularEaseCard = ({ title = "", imageUrl }) => (
  <div className={styles.cardContainer}>
    <div className={styles.outerCard}>
      <div className={styles.innerCard}>
        <img
          alt={title}
          src={
            imageUrl ||
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQohQTw7t8k515lP4TzJghRDy-hONJO6zC56A&s"
          }
          loading="lazy"
        />
      </div>
    </div>
    {title && <span className={styles.title}>{title}</span>}
  </div>
);

export default CircularEaseCard;
